<template>
	<div class="list-page">
		<el-tabs v-model="status" @tab-click="init">
			<el-tab-pane :label="$t('委托订单')" name="0"></el-tab-pane>
			<el-tab-pane :label="$t('交割订单')" name="1"></el-tab-pane>
			<el-tab-pane :label="$t('历史订单')" name="3"></el-tab-pane>
		</el-tabs>

		<div class="table-div">
			<div class="th-div dis-fle ali-cen">
				<span class="txt-ali-lef">{{ $t('产品') }}</span>
				<span>{{ $t('方向') }}</span>
				<span>{{ $t('开仓时间') }}</span>
				<span>{{ $t('开仓价') }}</span>
				<span>{{ $t('手续费') }}</span>
				<span>{{ $t('平仓时间') }}</span>
				<span>{{ $t('平仓价') }}</span>
				<span>{{ $t('数量') }}</span>
				<span>{{ $t('盈亏') }}</span>
			</div>
			<div class="tr-div dis-fle ali-cen" v-for="value in list" :key="value.id">
				<span class="txt-ali-lef">{{ value.product_title }}</span>
				<span :class="value.direction == 1 ? 'green' : 'red'">
					{{ value.direction == 1 ? $t('买涨') : $t('买跌') }}
				</span>
				<span>{{ value.createtime_text }}</span>
				<span>{{ value.open_price }}</span>
				<span>{{ value.fee }}</span>
				<span>{{ value.handletime_text }}</span>
				<span>{{ value.end_price }}</span>
				<span>{{ value.amount }}</span>
				<span :style="{ color: value.fact_profits > 0 ? '#00f0ff' : '#ff4834' }">
					{{ value.fact_profits }}
				</span>
			</div>

			<div class="dasda" v-if="list.length <= 0">{{ $t('没有更多数据了') }}</div>
		</div>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			class="padd-20" :total="page.total" @current-change="getdata" />
	</div>
</template>

<script>

import { get } from '@/http/request'
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		oPage,
	},
	props: {
		id: {
			type: [String, Number],
			default: ''
		},
	},
	data() {
		return {
			url: this.$apis.getOrderList,
			status: '0', // 0=委托中1=交易中3=已平仓 

			list: [],
			page: {
				page: 1,
				limit: 10,
				total: 10,
			},
		};
	},
	watch: {
		id() {
			this.init()
		}
	},
	created() {
	},
	methods: {

		init() {
			this.page.page = 1
			this.getdata()
		},
		getdata(showLoading = true) {
			get(this.url, {
				showLoading,
				...this.page,
				status: this.status,
				label: this.status,
				product_id: this.id
			}).then(res => {
				if (res.code != 1) return
				if (Array.isArray(res.data)) {
					this.list = res.data
					this.page.total = 0
					return
				}
				this.list = res.data.list || res.data.data
				this.page.total = res.data.total
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.list-page {
	padding: 10px 20px;

	.table-div {
		font-size: 16px;
		line-height: 40px;
		color: #999;
		text-align: center;

		.th-div {
			border-bottom: 1px solid #2b3139;
			padding-bottom: 8px;
		}

		span {
			flex: 1;
		}

		.dasda {
			text-align: center;
			margin: 50px auto;
			color: #888;
		}

	}

	.green {
		color: #00f0ff !important;
	}

	.red {
		color: #ff4834 !important;
	}
}
</style>